import React, { useState, useEffect } from 'react';
import './index.css';
import { isValidUser } from '../Utils/authUtils';
import { ICONS } from '@ohif/ui';
import classnames from 'classnames';
import { useNavigate, useLocation } from 'react-router-dom';
import { SuccessModal } from '@ohif/ui';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { resetPasswordValidationSchema, resetPasswordInitialValues } from './helper/schema';
import { ResetPasswordFormTypes } from './helper/auth';
import { useDispatch } from 'react-redux';
import resetPasswordApi from '../rtk-apis/authentication/resetPassword';
import { AppDispatch } from '../store/store';
import { removeUserCredentials } from '../Utils/authUtils';

const ResetPassword = () => {

  const navigate = useNavigate();
  const location = useLocation()
  const isInitialPasswordChange = Boolean(
    location.state?.initialPasswordChange ||
    sessionStorage.getItem('mustChangePassword') ||
    localStorage.getItem('mustChangePassword')
  );
  const { email = sessionStorage.getItem('email') || localStorage.getItem('email') } = location?.state || {}

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [successPopup, setSuccessPopup] = useState(false)
  const [apiErrorMessage, setApiErrorMessage] = useState('');

  const dispatch = useDispatch<AppDispatch>();

  const handleSubmit = async (values: ResetPasswordFormTypes) => {
    setApiErrorMessage('');
    try {
      const body = {
        email,
        newPassword: values.newPassword,
        confirmPassword: values.confirmPassword,
        initialPasswordChange: isInitialPasswordChange,
      }
      // Dispatch resetPasswordApi and await the result, unwrapping the response
      await dispatch(resetPasswordApi(body)).unwrap(); // Rejects with the API payload on failure

      // display success for 2 sec then redirect
      setSuccessPopup(true);
      setTimeout(() => {
        setSuccessPopup(false);
        if (isInitialPasswordChange) {
          removeUserCredentials();
        }
        navigate('/login');
      }, 500);
    } catch (error) {
      setApiErrorMessage((error as { msg?: string })?.msg || 'Failed to reset password. Please try again.');
    }
  };

  useEffect(() => {
    if ((!isInitialPasswordChange && isValidUser()) || !email) {
      navigate('/dashboard');
    }
  }, [email, isInitialPasswordChange, navigate]);

  return (
    <>
      <div className={classnames("h-screen w-full bg-cover bg-no-repeat bg-center")}
        style={{
          backgroundImage: "url('/assets/BG.png')",
          backgroundColor: '#eaf4f2',
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat',
          backgroundPosition:'right top',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between'
        }} >
        <img src={`${ICONS.Logo}`} className='logo' alt="Seven Hills Logo" />
        <div className={classnames("login-container w-[400px] h-[420px] p-6 bg-white text-black m-0 mx-auto rounded-lg transform -translate-x-1/2 -translate-y-1/2 absolute top-1/2 left-1/2 border border-gray-300 shadow-lg")}>
          <div className={classnames("flex flex-col justify-center items-center mb-4")}>
            <img className='w-12 h-12 mb-2' src={`${ICONS.ResetLock}`} alt="User_Icon" />
            <h1 className={classnames('text-black font-bold text-xl')}>Reset Password</h1>
          </div>
          <Formik
            initialValues={resetPasswordInitialValues}
            validationSchema={resetPasswordValidationSchema}
            onSubmit={handleSubmit}
          >
            {({ isSubmitting }) => (
              <Form>
                <div>
                  <div className={classnames("flex flex-col gap-[3px] my-[15px]")}>
                    <label className={`${classnames('form__label')} email_text`} htmlFor='email'>Password</label>
                    <div className='form__Field relative w-full'>
                      <Field
                        name="newPassword"
                        type={showPassword ? 'text' : 'password'}
                        placeholder="Enter your password"
                        className={classnames('form__input form__input--password')}
                      />
                      <img
                        className={classnames('iconPassword')}
                        src={`${ICONS.PasswordEye}`}
                        alt="password eye"
                        onClick={() => setShowPassword(!showPassword)}
                      />
                    </div>
                    <ErrorMessage name="newPassword" component="div" className="form__error" />
                  </div>
                  <div className={classnames("flex flex-col gap-[3px] my-[15px] mt-4")}>
                    <label className='form__label password_text' htmlFor='password'>Confirm Password</label>
                    <div className='form__Field relative w-full'>
                       <Field
                        name="confirmPassword"
                        type={showConfirmPassword ? 'text' : 'password'}
                        placeholder="Re-enter your password"
                        className={classnames('form__input form__input--password')}
                      />
                      <img
                        className={classnames('iconPassword')}
                        src={`${ICONS.PasswordEye}`}
                        alt="password eye"
                        onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                      />
                    </div>
                    <ErrorMessage name="confirmPassword" component="div" className="form__error" />
                  </div>
                  {apiErrorMessage && (
                    <p className="form__error text-center">{apiErrorMessage}</p>
                  )}
                  <div className='mt-5 w-full mb-1 btn__group btn__group--full'>
                    <button type='submit' disabled={isSubmitting} className='btn btn__primary btn--full'>Done</button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
      <SuccessModal
        isSuccessModalOpen={successPopup}
        title={'Password Changed Successfully.'}
        handleCloseModal={() => setSuccessPopup(false)}
      />
    </>
  );
};
export default ResetPassword;
